module.exports = __webpack_public_path__ + "static/media/delete.aa443743.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/delete.png
 ** module id = 320
 ** module chunks = 0
 **/